import { Platform } from 'react-native'
import { isLegacyIosFabricCrashRuntime } from '../platform/legacy-ios-fabric'

/**
 * Android + RN Screens + the New Architecture can throw while removing
 * screens during stack transitions (TAGO-MOBILE-1Z ViewGroup / FragmentManager).
 * iOS 1.2.0 / 1.2.1 fatals in the same window during UINavigationController
 * transitions (TAGO-MOBILE-40). Keep those stacks still; current iOS keeps
 * native motion; web stays instant.
 */
export const stableStackOptions =
  Platform.OS === 'android' || Platform.OS === 'web'
    ? ({
        animation: 'none' as const,
        // TAGO-MOBILE-1Z: Fabric + RN Screens removes a child that the
        // FragmentManager already tore down when inactive tabs detach.
        // Keep them mounted on Android; memory cost is the crash tax.
        detachInactiveScreens: false,
        // Do not freeze a Fabric tree while RN Screens is keeping its native
        // fragment mounted. A frozen child can resume after FragmentManager
        // has already applied the detach batch, which is the second half of
        // TAGO-MOBILE-1Z's `ensureExecReady` / "Cannot remove child" crash.
        freezeOnBlur: false,
      } as const)
    : isLegacyIosFabricCrashRuntime()
      ? ({ animation: 'none' as const } as const)
      : {}

export function platformStackAnimation(
  iosAnimation: 'slide_from_right' | 'fade_from_bottom',
): 'none' | 'slide_from_right' | 'fade_from_bottom' {
  if (isLegacyIosFabricCrashRuntime() || Platform.OS !== 'ios') return 'none'
  return iosAnimation
}
